import { load, hashComponents, componentsToDebugString } from "./agent";
import { x64hash128 } from "./util/hashing";
// Exports that are under Semantic versioning
export { load, hashComponents, componentsToDebugString };
// The default export is a syntax sugar (`import * as FP from '...' → import FP from '...'`).
// It should contain all the public exported values.
export default {
  load: load,
  hashComponents: hashComponents,
  componentsToDebugString: componentsToDebugString
};

// The exports below are for private usage. They may change unexpectedly. Use them at your own risk.
/** Not documented, out of Semantic Versioning, usage is at your own risk */
export var murmurX64Hash128 = x64hash128;
export { prepareForSources } from "./agent";
export { sources } from "./source";
export { getUnstableCanvasFingerprint } from "./source/canvas";
// export { getUnstableScreenFrame } from "./source/screen_frame"
export { getUnstableScreenResolution } from "./source/screen_resolution";
export { getWebGLContext } from "./source/webgl";
export { loadSources, transformSource // Not used here but adds only 222 uncompressed (60 compressed) bytes of code
} from "./util/entropy_source";